<template>
    <div>
        <h1>How to enter player names</h1>
        <h3>Loading screen: </h3>
        <p>
            Players are ordered 1 to 8, it looks like this:<br>
            1-2-3-4<br>
            5-6-7-8
        </p>
        <h3>PvE rounds: </h3>
        <p>
            Players are ordered 1 to 8, right side with player list looks like this:<br>
            1-2-3-4-5-6-7-8 (from top to bottom)
        </p>
        <h3>After PvE rounds: </h3>
        <p>During "waiting time" before fights, click on each island and check who it is. Alternatively click on player name to find on which island he is.</p>
        <h3>App order: </h3>
        <p>
            Players are ordered the same way as in-game, so like this:<br>
            8-1-2<br>
            7-x-3<br>
            6-5-4
        </p>
        <h1>Useful tip:</h1>
        <p>Enter only first word or few letters, not full nickname. There is no point to write full nickname.</p>
    </div>
</template>

<script>
    export default {
        name: "HowToEnterNames"
    }
</script>

<style>
</style>